import { ReactComponent } from "./yellow-check-fill.svg";

interface Props {
  style?: React.CSSProperties;
}

const YellowCheckFillIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default YellowCheckFillIcon;
